import { Route, Routes } from 'react-router';

import EvaluationPage from '../pages/EvaluationPage';

const EvaluationRoutes = () => {
  return (
    <Routes>
      <Route path=":evaluationId" element={<EvaluationPage />} />
    </Routes>
  );
};

export default EvaluationRoutes;
